var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"box"},[_c('div',{staticClass:"status"},[_vm._t("head")],2),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"footer"},[_vm._t("footer")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }